import React from "react";
import { IconButton, Button } from "@material-ui/core";
import { SlotTimeRange, useStyles, ModalDialog } from "@ui/booking-modal";
import { DateTime } from "luxon";
import { getFormattedDateTimeTz } from "@util/date.util";
import { Event } from "@material-ui/icons";
import { Close } from "@material-ui/icons";

export type Props = {
  slotTimeRange?: SlotTimeRange;
  title: string;
  fullscreen: boolean;
  onClose: () => void;
};

export function TimeUnavailableModal({ slotTimeRange, title, fullscreen, onClose }: Props) {
  const classes = useStyles();
  const dateTime = DateTime.fromISO(slotTimeRange ? slotTimeRange.startTime.dateOrDateTime : "");

  return (
    <ModalDialog
      open={!!slotTimeRange}
      onClose={onClose}
      fullscreen={fullscreen}
      cw-id="link-booking-modal"
    >
      <>
        <div className={classes.headerAndClose}>
          <h2 className={classes.header}>Book this time</h2>
          <IconButton onClick={onClose} className={classes.close} cw-id="close-booking-modal">
            <Close />
          </IconButton>
        </div>
        <div>
          <div className="cw-flex cw-justify-center cw-gap-4 cw-bg-yellow-lightest cw-border cw-border-solid cw-border-yellow-lightest cw-p-4 cw-rounded-lg cw-leading-relaxed cw-mb-4">
            <span className="cw-pt-1">
              <Event className="cw-text-[18px] cw-fill-slate-standard" />
            </span>
            <div>
              <div className="cw-text-dusk-darker cw-font-bold">{title}</div>
              <div className="cw-line-through cw-text-sm cw-text-dusk-standard">
                {dateTime.isValid &&
                  getFormattedDateTimeTz(dateTime) + " " + dateTime.offsetNameShort}
              </div>
              <div className="cw-text-yellow-darkest cw-font-bold cw-text-sm">
                This time is no longer available
              </div>
            </div>
          </div>
          <Button
            onClick={onClose}
            variant="contained"
            color="primary"
            size="large"
            aria-label="choose another time"
            fullWidth
          >
            Choose another time
          </Button>
        </div>
      </>
    </ModalDialog>
  );
}
